import { render, staticRenderFns } from "./tzcunkuan.vue?vue&type=template&id=faaeadd4&scoped=true"
import script from "./tzcunkuan.vue?vue&type=script&lang=js"
export * from "./tzcunkuan.vue?vue&type=script&lang=js"
import style0 from "./tzcunkuan.vue?vue&type=style&index=0&id=faaeadd4&prod&lang=scss&scoped=true"
import style1 from "./tzcunkuan.vue?vue&type=style&index=1&id=faaeadd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaeadd4",
  null
  
)

export default component.exports